import {
  createRouter,
  createWebHistory
} from "vue-router";

// 导入路由组件
import Home from "@/views/home/Home.vue";
import Login from "@/views/login/Login.vue";
import NotFound from "@/views/notFound/NotFound.vue";
// 关于我们
import Company from "@/views/about/Company.vue";
import Digital from "@/views/about/Digital.vue";
import Efficient from "@/views/about/Efficient.vue";
import Marketing from "@/views/about/Marketing.vue";
import Partner from "@/views/about/Partner.vue";
import Quality from "@/views/about/Quality.vue";
import Social from "@/views/about/Social.vue";
// 新闻中心
import New from "@/views/news/New.vue";
import MediaCenter from "@/views/news/MediaCenter.vue";
// 联系我们
import ContactWay from "@/views/contact/ContactWay.vue";
import Register from "@/views/contact/Register.vue";
import TalentPlan from "@/views/talentPlan/TalentPlan.vue";
// 底部导航
import Map from "@/views/home/Map.vue";
import Privacy from "@/views/home/Privacy.vue";
import Clause from "@/views/home/Clause.vue";
import Statute from "@/views/home/Statute.vue";
// 新闻详情页
import Newpage from "../views/news/Newpage.vue";
//产品列表页
import ProductList from "../views/home/repeat/ProductList.vue";
//产品详情页
import Product from "../views/home/repeat/Product.vue";
//产品系统页
import ProductSystem from "../views/home/ProductSystem.vue";

const routes = [
  {
    path: "/:lang(zh|en)?",
    children: [
      {
        path: "",
        redirect: to => `/${to.params.lang || 'zh'}/home`
      },
      {
        path: "home",
        component: Home,
      },
      {
        path: "home/productlist",
        component: ProductList,
      },
      {
        path: "home/product/:id",
        component: Product,
      },
      {
        path: "home/product-system",
        component: ProductSystem,
        props: true,
      },
      {
        path: "home/map",
        component: Map,
      },
      {
        path: "home/privacy",
        component: Privacy,
      },
      {
        path: "home/clause",
        component: Clause,
      },
      {
        path: "home/statute",
        component: Statute,
      },
      {
        path: "contact",
        children: [
          {
            path: "contactway",
            component: ContactWay,
          },
          {
            path: "register",
            component: Register,
          },
        ]
      },
      {
        path: "about",
        children: [
          {
            path: "company",
            component: Company,
          },
          {
            path: "digital",
            component: Digital,
          },
          {
            path: "efficient",
            component: Efficient,
          },
          {
            path: "marketing",
            component: Marketing,
          },
          {
            path: "partner",
            component: Partner,
          },
          {
            path: "quality",
            component: Quality,
          },
          {
            path: "social",
            component: Social,
          },
        ]
      },
      {
        path: "news",
        children: [
          {
            path: "",
            redirect: "new"
          },
          {
            path: "new",
            component: New,
          },
          {
            path: "media",
            component: MediaCenter,
          },
          {
            path: "newpage/:id",
            component: Newpage,
          },
        ]
      },
      {
        path: "talentPlan",
        component: TalentPlan,
      },
      {
        path: "login",
        component: Login,
      },
      {
        path: "notFound",
        component: NotFound,
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => `/zh/notFound`
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  const lang = to.params.lang;
  
  // 如果没有语言参数，重定向到默认语言
  if (!lang) {
    const defaultLang = localStorage.getItem("locale") === "en" ? "en" : "zh";
    next({
      path: `/${defaultLang}${to.path}`,
      query: to.query,
      hash: to.hash
    });
    return;
  }
  
  // 如果语言参数不合法，重定向到中文
  if (!["zh", "en"].includes(lang)) {
    next({
      path: `/zh${to.path.substring(3)}`,
      query: to.query,
      hash: to.hash
    });
    return;
  }

  // 设置语言并确保语言更新生效
  const newLocale = lang === "en" ? "en" : "zh-cn";
  if (localStorage.getItem("locale") !== newLocale) {
    localStorage.setItem("locale", newLocale);
    // 强制更新 i18n 的 locale
    window.location.reload();
    return;
  }
  if (to.path.includes('/home')) {
    to.meta.isHome = true;
  }

  // 强制页面滚动到顶部
  window.scrollTo(0, 0);
  next();
});

export default router;